import { Col, Row, Spinner, Form as BForm, Button } from '@themesberg/react-bootstrap'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import ProviderFilter from '../../../../../components/ProviderFilter'
import { InlineLoader } from '../../../../../components/Preloader'
import { getAllCasinoGamesStart, getFreeSpinGamesStart } from '../../../../../store/redux-slices/superAdminCasinoManagement'
import GamesListEdit from './GamesListEdit'
import useDidMountEffect from '../../../../../utils/useDidMountEffect'
import { getAllMasterGamesStart, getTAFreeSpinGamesStart } from '../../../../../store/redux-slices/tenantCasino'

const Games = ({
  gameIds,
  setGameIds,
  setLimit,
  setPageNo,
  setSearch,
  search,
  totalPages,
  limit,
  pageNo,
  handleSubmit,
  handleBlur,
  casinoGamesData,
  selectedProvider,
  setSelectedProvider,
  setSelectedTab,
  isEdit,
  errors,
  isTenant,
  details,
  isClone,
  values
}) => {
  const dispatch = useDispatch()
  const { bonusId } = useParams()
  const isInitialRender = useDidMountEffect()
  const [change, setChange] = useState(false)
  const { bonusDetail } = useSelector(state => state.bonus)
  const { loading: SALoading } = useSelector(state => state.superAdminCasino)
  const { loading: TALoading } = useSelector(state => state.tenantCasino)
  const loading = isTenant ? TALoading : SALoading

  useEffect(() => {
    if (bonusDetail?.gameIds) {
      setGameIds(bonusDetail?.gameIds)
    }
  }, [bonusDetail])

  const TAFreeSpin = () => {
    (values?.bonusType === 'freespins' || values?.bonusType === 'cashfreespins') &&
    dispatch(
      getTAFreeSpinGamesStart({
        limit,
        pageNo,
        search,
        providerId: selectedProvider,
        bonusId
      })
    )
  }
  const SAFreeSpin = () => {
    (values?.bonusType === 'freespins' || values?.bonusType === 'cashfreespins') &&
    dispatch(
      getFreeSpinGamesStart({
        limit,
        pageNo,
        search,
        providerId: selectedProvider,
        bonusId
      }))
  }
  const SAGames = () => {
    (values?.bonusType === 'freespins' || values?.bonusType === 'cashfreespins') &&
    dispatch(
      getAllCasinoGamesStart({
        limit,
        pageNo,
        casinoCategoryId: '',
        search,
        isActive: '',
        tenantId: '',
        selectedProvider,
        freespins: true,
        bonusId: isEdit ? bonusId : ''
      })
    )
  }

  const TAGames = () => {
    (values?.bonusType === 'freespins' || values?.bonusType === 'cashfreespins') &&
    dispatch(
      getAllMasterGamesStart({
        limit,
        pageNo,
        search,
        casinoCategoryId: '',
        providerId: selectedProvider,
        freespins: true,
        bonusId
      })
    )
  }

  useEffect(() => {
    setPageNo(1)
    if ((isEdit || details) && bonusId && !change) {
      isTenant
        ? TAFreeSpin()
        : SAGames()
    } else {
      isTenant
        ? TAGames()
        : SAGames()
    }
  }, [limit, bonusId, selectedProvider])

  useEffect(() => {
    if (!isInitialRender) {
      if ((isEdit || details) && bonusId && !change) {
        isTenant
          ? TAFreeSpin()
          : SAGames()
      } else {
        isTenant
          ? TAGames()
          : SAGames()
      }
    }
  }, [pageNo])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (pageNo === 1) {
          if ((isEdit || details) && bonusId && !change) {
            !isTenant
              ? SAFreeSpin()
              : SAGames()
          } else {
            isTenant
              ? TAGames()
              : SAGames()
          }
        } else {
          setPageNo(1)
        }
      }
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  return (
    <>
      <Row className='d-flex'>
        <Col xs='auto' className='d-flex align-items-center provider'>
          <ProviderFilter
            selectedProvider={selectedProvider}
            setSelectedProvider={setSelectedProvider}
            isTenantRoute={isTenant}
          />
        </Col>
        <Col xs='auto' className='d-flex align-items-center'>
          <BForm.Label>
            Search
          </BForm.Label>

          <BForm.Control
            type='search'
            size='sm'
            style={{ marginLeft: '10px', maxWidth: '230px' }}
            placeholder='Search Game Name'
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onBlur={handleBlur}
          />
        </Col>
        {isEdit && bonusId &&
          <Col className='d-flex justify-content-end'>
            <Button
              variant='success'
              onClick={() => {
                setChange(true)
                setPageNo(1)
                setLimit(15)
                isTenant
                  ? TAGames()
                  : SAGames()
              }}
            >Add
            </Button>
          </Col>}
      </Row>

      <Row />

      {loading
        ? <InlineLoader />
        : (
          <Row>
            {casinoGamesData &&
              <GamesListEdit
                gameIds={gameIds}
                casinoGamesData={casinoGamesData || []}
                setGameIds={setGameIds}
                page={pageNo}
                limit={limit}
                setLimit={setLimit}
                setPage={setPageNo}
                totalPages={totalPages}
                isEdit={isEdit}
                isTenant={isTenant}
                details={details}
              />}
          </Row>)}

      {!details &&
        <div
          className='mt-4 d-flex justify-content-between align-items-center'
        >
          <Button
            variant='outline-warning'
            onClick={() => setSelectedTab(values?.bonusType === 'freespins' && values?.isSticky ? 'wageringContribution' : 'currency')}
          >
            Previous
          </Button>

          <div>
            <Button
              variant='outline-success'
              onClick={() => {
                handleSubmit()
              }}
            >
              Next
              {loading && (
                <Spinner
                  as='span'
                  animation='border'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              )}
            </Button>
          </div>
        </div>}
    </>
  )
}

export default Games
